import { ColumnEventType, ColumnState, GridApi } from 'ag-grid-community';
import { debounce } from '../resources/helper-functions/deboucefunc';
import { autoinject } from 'aurelia-framework';
import { CustomerService } from '@dynamik/common';
import { ca } from 'date-fns/locale';

@autoinject
export class AgGridState {
  constructor(private customerService: CustomerService) {
    const func = (gridApi: GridApi, prefix: string, source: string) => {
      this.saveGridState(gridApi, prefix, source);
    };
    this.saveGridStateDebounced = debounce<typeof func>(func, 500);
  }

  public saveGridStateDebounced: (gridApi: GridApi, prefix: string, source?: string ) => Promise<ReturnType<any>>;

  getItem(key: string) {
    return localStorage.getItem(`Company_${this.customerService.selectedCustomer.companyId}_${key}`) ?? localStorage.getItem(key);
  }

  setItem(key: string, value: string) {
    localStorage.setItem(`Company_${this.customerService.selectedCustomer.companyId}_${key}`, value);
  }

  restoreGridState(gridApi: GridApi, prefix: string) {
    const colStateString = this.getItem(`${prefix}ColState`);
    if (!colStateString) {
      return;
    }
    try {
      const сolumnsFromHtml = gridApi.getColumnState();
      const columnsFromLocalStorage = JSON.parse(colStateString) as ColumnState[];

      if (сolumnsFromHtml.length === columnsFromLocalStorage.length) {
        gridApi.applyColumnState({ state: columnsFromLocalStorage, applyOrder: true });
        gridApi.setFilterModel(JSON.parse(this.getItem(`${prefix}FilterState`)));
      }
    }
    catch (e) {
      // ignore
    }
  }

  saveGridState(gridApi: GridApi, prefix: string, source: string = undefined) {
    if (!gridApi || ['gridInitializing'].includes(source)) {
      return;
    }
    this.setItem(`${prefix}ColState`, JSON.stringify(gridApi.getColumnState()));
    this.setItem(`${prefix}FilterState`, JSON.stringify(gridApi.getFilterModel()));
  }

  restoreFilter(gridApi: GridApi, prefix: string) {
    if (!this.getItem(`${prefix}FilterState`)) {
      return;
    }
    gridApi.setFilterModel(JSON.parse(this.getItem(`${prefix}FilterState`)));
  }

  saveFilter(gridApi: GridApi, prefix: string) {
    if (!gridApi) {
      return;
    }
    this.setItem(`${prefix}FilterState`, JSON.stringify(gridApi.getFilterModel()));
  }

  saveGridFilter(prefix: string, state: unknown) {
    this.setItem(`${prefix}GridFilterState`, JSON.stringify(state));
  }

  restoreGridFilter<T>(prefix: string): T | null {
    const stateString = this.getItem(`${prefix}GridFilterState`);
    if (!stateString) {
      return null;
    }
    try {
      return JSON.parse(stateString) as T;
    }
    catch (e) {
      return null;
    }
  }

  restoreColumn(gridApi: GridApi, prefix: string) {
    if (!this.getItem(`${prefix}ColState`)) {
      return;
    }
    gridApi.applyColumnState({ state: JSON.parse(this.getItem(`${prefix}ColState`)) as ColumnState[], applyOrder: true });
  }

  saveColumn(gridApi: GridApi, prefix: string) {
    if (!gridApi) {
      return;
    }
    this.setItem(`${prefix}ColState`, JSON.stringify(gridApi.getColumnState()));
  }
}
